"use client"

import { useInViewConfig, useIsMobile, useTransitionUpStyles } from "@/ui"
import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import React, { useState } from "react"
import { useInView } from "react-intersection-observer"
import DesktopView from "./DesktopView"
import MobileView from "./MobileView"
import { InvestmentData, transformTabData } from "./utils"

// Styled components
const StyledTabsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: white;
`

interface BestInvestTabsProps {
  tabs: any[]
  investmentData: InvestmentData
}

const BestInvestTabs: React.FC<BestInvestTabsProps> = ({
  tabs = [],
  investmentData,
}) => {
  const [value, setValue] = useState(0)
  const { ref, inView } = useInView(useInViewConfig)
  const transitionStyles = useTransitionUpStyles(inView)
  const isMobile = useIsMobile()
  const t = useTranslations("BestInvest")

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  // Transform the data structure
  const transformedTabs = transformTabData(tabs || [])

  // Guard clause for empty tabs
  if (!transformedTabs || transformedTabs.length === 0) {
    return <Typography color="white">{t("noTabContent")}</Typography>
  }

  return (
    <StyledTabsContainer ref={ref} style={transitionStyles}>
      {isMobile ? (
        <MobileView
          tabs={transformedTabs}
          value={value}
          onSlideChange={setValue}
          investmentData={investmentData}
        />
      ) : (
        <DesktopView
          tabs={transformedTabs}
          value={value}
          onChange={handleChange}
          investmentData={investmentData}
        />
      )}
    </StyledTabsContainer>
  )
}

export default BestInvestTabs
